export default __webpack_public_path__ + "static/media/volunteering_infographic.1856bf8d.jpg";